import React from 'react';
import styles from './Achievements.module.css';
import { achievements, certifications } from '../data/portfolio';

export default function Achievements() {
  return (
    <div className="stack fade-in" style={{ marginBottom: '64px' }}>
      <div className="stack-inner">
        <div className={styles.inner}>
          <p className="section-label" style={{ marginBottom: '16px' }}>Achievements & certifications</p>
          <div className={styles.grid}>
            {achievements.map((a) => (
              <div key={a.title} className={styles.item}>
                <div className={styles.icon}>{a.icon}</div>
                <div className={styles.title}>{a.title}</div>
                <div className={styles.sub}>{a.sub}</div>
              </div>
            ))}
          </div>
          <div className={styles.certRow}>
            {certifications.map((c) => (
              <span key={c} className={styles.cert}>
                <span className={styles.dot} />
                {c}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
